import h from 'hyperscript';
import generateIcon from 'components/_particles/icon/icon';

export default class GridExpandable {
  constructor($grid) {
    this.$grid = $grid;
    this.$gridInner = this.$grid.querySelector('.grid__inner');
    this.$items = this.$grid.querySelectorAll('.grid__item');
    this.$button = false;

    this.id = this.$grid.id;
    this.itemsShown = parseInt(this.$grid.dataset.itemsShown, 10);
    this.itemsTotal = this.$items.length;
    this.expanded = false;

    this.options = {
      moreButton: {
        iconCollapsed: 'add-line',
        iconExpanded: 'subtract-line',
        textCollapsed: this.$grid.dataset.labelCollapsed || 'Show all',
        textExpanded: this.$grid.dataset.labelExpanded || 'Show less',
      },
    };

    if (this.itemsTotal > this.itemsShown) {
      this.init();
    } else {
      for (let i = 0; i < this.itemsTotal; i += 1) {
        const $item = this.$items[i];
        $item.removeAttribute('hidden');
      }
    }
  }

  init() {
    // Hide all items > itemsShown
    for (let i = 0; i < this.itemsShown; i += 1) {
      const $item = this.$items[i];
      $item.removeAttribute('hidden');
    }

    // Create binded click for toggle button
    this.bindedClick = this.toggleItems.bind(this);

    // Generate Toggle-Button
    this.createButton();
  }

  createButton() {
    const $buttonContainer = h('.grid__button');
    const $button = h('button.button', {
      type: 'button',
    }, [generateIcon({
      icon: this.expanded
        ? this.options.moreButton.iconExpanded : this.options.moreButton.iconCollapsed,
      classes: ['button__icon'],
    })], h('span.button__text', this.expanded ? this.options.moreButton.textExpanded : this.options.moreButton.textCollapsed));

    $button.addEventListener('click', this.bindedClick);

    $buttonContainer.append($button);
    this.$gridInner.append($buttonContainer);
  }

  toggleItems() {
    this.$gridInner.querySelector('.grid__button').remove();

    this.expanded = !this.expanded;

    for (let i = this.itemsShown; i < this.itemsTotal; i += 1) {
      const $item = this.$items[i];
      $item.toggleAttribute('hidden');
    }

    if (!this.expanded) {
      this.$grid.scrollIntoView();
    }

    this.createButton();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-grid-expandable').forEach(
    $gridExpandable => new GridExpandable($gridExpandable),
  );
});
